import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-patient-eid-dialog',
  templateUrl: './patient-eid-dialog.component.html',
  styleUrls: ['./patient-eid-dialog.component.scss']
})
export class PatientEidDialogComponent implements OnInit {

  public eiddata;
  public displaySearch = false;
  private monthmapping = new Map([
    ['JAN', '01'],
    ['FEV', '02'],
    ['MAR', '03'],
    ['AVR', '04'],
    ['MAI', '05'],
    ['JUIN', '06'],
    ['JUIL', '07'],
    ['AOU', '08'],
    ['SEP', '09'],
    ['OCT', '10'],
    ['NOV', '11'],
    ['DEC', '12'],
  ]);

  constructor(private dialogRef: MatDialogRef<PatientEidDialogComponent>, @Inject(MAT_DIALOG_DATA) data,
              private patient: PatientService) {
    this.eiddata = data;
  }

  ngOnInit(): void {
    this.patient.search(this.eiddata.national_number).subscribe(result => {
      if (result.length > 1) {
        // Close and start search
        this.close(new Map<string, any>([
          ['action', 'search'],
          ['search', this.eiddata.national_number]
        ]));
      }
      if (result.length === 1) {
        this.close(new Map<string, any>([
          ['action', 'select'],
          ['patient', result[0]]
        ]));
      }
      if (result.length === 0) {
        // niss not found, search on birthdate
        const dateparts: string[] = this.eiddata.date_of_birth.split(' ');
        let monthnumeric = '';
        this.monthmapping.forEach((value, key) => {
          if (key.startsWith(dateparts[1])) {
            monthnumeric = value;
          }
        });
        dateparts[1] = monthnumeric;
        this.close(new Map<string, any>([
          ['action', 'search'],
          ['search', dateparts.join('/')]
        ]));
      }
    });
  }

  updatePatient(): void {

  }

  close(returns: Map<string, any>) {
    this.dialogRef.close(returns);
  }
}
